module.exports = __webpack_public_path__ + "static/media/how-it-works-landlord-t2-8.1df4611a.svg";